const FA = '۰۱۲۳۴۵۶۷۸۹';
const AR = '٠١٢٣٤٥٦٧٨٩';

export const toPersianDigits = (input: string | number): string =>
  String(input).replace(/\d/g, (d) => FA[Number(d)] ?? d);

export const toEnglishDigits = (input: string): string =>
  input
    .replace(/[۰-۹]/g, (d) => String(FA.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(AR.indexOf(d)));

/** 1234567 → "1,234,567" (the Vazirmatn-FD font renders the digits in Persian). */
export const formatNumber = (n: number): string =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(n));

export const formatRial = (n: number) => `${formatNumber(n)} ریال`;
export const formatToman = (n: number) => `${formatNumber(n)} تومان`;
